window.chartVermoegensaufteilungPartner = {
    init: function() {
        this.chart = new Highcharts.Chart({
            chart: {
                type: 'pie',
                renderTo: 'chart_vermoegensaufteilung_partner',
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                marginBottom: 10,
                spacingBottom: 0,
                events: {
                    render: function () {
                        var chart = this,
                            series = chart.series,
                            allZeros = true;
                        for (var i = 0; i < series[0].data.length; i++) {
                            if (series[0].data[i].y !== 0) {
                                allZeros = false;
                            }
                        }
                        if (allZeros) {
                            chart.showLoading('Keine Daten vorhanden');
                        } else {
                            chart.hideLoading();
                        }
                    }
                }
            },
            title: {
                text: ''
            },
            credits: {
                enabled: false
            },
            legend: {
                enabled: false,
            },
            tooltip: {
                useHTML: true,
                headerFormat: '',
                pointFormatter: function() {
                    return `${this.name}<br/><b>${Highcharts.numberFormat(this.percentage, 0)}%</b>`;
                },
                style: {
                    fontFamily: 'Open Sans',
                    fontSize: '14px',
                    textAlign: 'center'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    slicedOffset: 5,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    animation: {
                        duration: chartAnimationDuration,
                        easing: 'easeInOut'
                    },
                },
            },
            series: this.chartdata()
        });
    },

    chartdata: () => {
        const   data                    = [],
                vermoegensbilanz        = document.querySelector('.vermoegensaufteilung_partner'),
                vermoegenswertgruppen   = vermoegensbilanz.querySelectorAll('.vermoegenswertgruppe')

        vermoegenswertgruppen.forEach( vermoegenswertgruppe => {
            const   vermoegenswerte = vermoegenswertgruppe.querySelector('.vermoegenswerte'),
                    farbe           = getGradientColor(vermoegenswertgruppe.dataset.farbe)

            const   bezeichnung = vermoegenswertgruppe.querySelector('.titel .bezeichnung').innerHTML,
                    summe       = make_f(vermoegenswertgruppe.querySelector('.titel .betrag').innerHTML, 0)

            data.push({
                name:   bezeichnung,
                color:  farbe,
                y:      summe
            })
        })

        return series = [{
                            name: '',
                            id: 'bruttovermoegenswerte',
                            size: '100%',
                            data: data
                        }]
    }
}
